/** @jsxImportSource @emotion/react */

import { colors } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../packages/kiti/components/presentation/Text'
import { useColor } from '../../packages/kiti/components/theme/_hooks/colors'
import Container from '../structure/Container'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Panel, { PanelContent } from '../structure/Panel'
import Plain from '../../packages/kiti/components/helpers/Plain'
import breakpoints from '../../utils/constants/breakpoints'

const PageHeaderPanelFooter = ({ children, absolute }) => {
  if (!absolute) return children
  const style = css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    @media (max-width: ${breakpoints.md}px) {
      position: static;
    }
  `

  return <div _css={style}>{children}</div>
}

const PageHeaderPanel = props => {
  let {
    leftIcon,
    leftAction,
    absoluteFooter,
    bgColor,
    bgImage,
    title,
    subtitle,
    titleContent,
    footer,
    side,
    mediumPadding,
    smallPaddingTopBottom,
    noContainer,
    noWrap
  } = props

  const style = css`
    position: relative;
    height: 100%;
  `

  bgColor = useColor(bgColor || 'dark1')

  const Wrapper = noContainer ? Plain : Container

  return (
    <Panel bgColor={bgColor} bgImage={bgImage} noPadding noMargin noRadius center noShadow minHeight="4.75rem">
      <div css={style}>
        <PanelContent
          noPaddingBottom={!!footer}
          mediumPadding={mediumPadding}
          smallPaddingTopBottom={smallPaddingTopBottom}
        >
          <Wrapper style={{ height: '100%' }}>
            <Grid wrap gap={1} justify="center" align="center" height="100%">
              <Col flex={1} wrapOn={!noWrap && 'sm'}>
                <Grid justify="flex-start" gutter={0.5}>
                  {leftIcon && <Icon name={leftIcon} color={colors.white} size="32px" onClick={leftAction} />}

                  <Col flex={1}>
                    {titleContent}
                    <Title size="h4" color="white" noMargin>
                      {title}
                    </Title>

                    <SmallText size="small" color="white" hideIfEmpty marginTop={-0.3}>
                      {subtitle}
                    </SmallText>
                  </Col>
                </Grid>
              </Col>
              {side && <Col>{side}</Col>}
            </Grid>
          </Wrapper>
        </PanelContent>
        {footer && <PageHeaderPanelFooter absolute={absoluteFooter}>{footer}</PageHeaderPanelFooter>}
      </div>
    </Panel>
  )
}

export default PageHeaderPanel
